var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinnovaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 24,
    viewBox: "0 0 217 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7577 0.454834H43.2842V23.0554H48.7577V0.454834Z",
    fill: "#24870F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.607 23.0554L180.518 0.454834H174.9L166.942 16.933L159.02 0.454834H153.402L164.313 23.0554H169.607Z",
    fill: "#24870F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5393 23.0554L38.1706 0.454834H32.2649L23.5865 16.933L7.52608 0.454834H0L21.4259 23.0554H26.5393Z",
    fill: "#24870F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.421 0.454834L178.79 23.0554H184.731L193.374 6.57728L209.47 23.0554H216.96L195.534 0.454834H190.421Z",
    fill: "#24870F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1978 8.32655V23.0554H57.7603V0.454834H63.1978L76.9896 15.1487V0.454834H82.4271V23.0554H76.9896L63.1978 8.32655Z",
    fill: "#24870F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.327 8.32655V23.0554H90.8535V0.454834H96.327L110.083 15.1487V0.454834H115.556V23.0554H110.083L96.327 8.32655Z",
    fill: "#24870F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.622 19.0321C141.447 19.0321 144.58 16.4781 144.58 11.8601C144.58 7.41691 141.591 4.93294 136.622 4.93294C131.652 4.93294 128.664 7.41691 128.664 11.8601C128.664 16.5131 131.76 19.0321 136.622 19.0321ZM123.082 11.7901C123.082 4.23324 128.159 0 136.622 0C145.084 0 150.162 4.23324 150.162 11.7901C150.162 19.6618 144.868 24 136.622 24C128.375 24 123.082 19.6618 123.082 11.7901Z",
    fill: "#24870F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinnovaLogo);
export default __webpack_public_path__ + "static/media/vinnova_logo.fec8961b7b09ca45c5989a9e883d4131.svg";
export { ForwardRef as ReactComponent };